import { NgModule, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { ServiceProviderRoutingModule } from './service-provider-routing.module';
import { MyServicesLayoutComponent } from './my-services-layout/my-services-layout.component';
import { SocialMediaShareComponent } from './available-services-layout/service-result/social-media-share/social-media-share.component';
import { MaterialModule } from '../shared/material.module';
import { NoServicesComponent } from './my-services-layout/no-services/no-services.component';
import { ServiceFormComponent } from './my-services-layout/service-form/service-form.component';
import { AvailableServicesLayoutComponent } from './available-services-layout/available-services-layout.component';
import { ServiceResultComponent } from './available-services-layout/service-result/service-result.component';
import { MyServicesService } from './my-services-layout/my-services.service';
import { AvailableServicesService } from './available-services-layout/available-services.service';
import { TagSelectorComponent } from './my-services-layout/tag-selector/tag-selector.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BUCKET } from '@angular/fire/storage';
import { ServicesSearchComponent } from './available-services-layout/services-search/services-search.component';
import { ContactModule } from '../contact/contact.module';
import { UserModule } from '../user/user.module';
import { HighlightedServicesComponent } from './highlighted-services/highlighted-services.component';
import { CoreModule } from '@angular/flex-layout';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatSidenavModule } from '@angular/material/sidenav';


@NgModule({
  declarations: [
    MyServicesLayoutComponent,
    NoServicesComponent,
    ServiceFormComponent,
    AvailableServicesLayoutComponent,
    ServiceResultComponent,
    TagSelectorComponent,
    ServicesSearchComponent,
    HighlightedServicesComponent,
    SocialMediaShareComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    MatBottomSheetModule,
    MatSidenavModule,
    ServiceProviderRoutingModule,
    UserModule,
    ContactModule
  ],
  exports: [HighlightedServicesComponent],
  providers: [
    MyServicesService,
    { provide: MatBottomSheetRef, useValue: {} },
    { provide: MAT_BOTTOM_SHEET_DATA, useValue: {} },
    AvailableServicesService,
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => TagSelectorComponent)
    },
    {
      provide: BUCKET,
      useValue: ''
    }
  ]
})
export class ServiceProviderModule {}
